/** Reported to Google with the token; shows up per-action in the reCAPTCHA console. */
const ACTION = 'register'

/** Resolve a v3 token, or reject if the Google script never loaded (blocked, offline). */
function requestToken(siteKey) {
    return new Promise((resolve, reject) => {
        const { grecaptcha } = window
        if (!grecaptcha) {
            reject(new Error('reCAPTCHA script not loaded'))
            return
        }

        grecaptcha.ready(() => grecaptcha.execute(siteKey, { action: ACTION }).then(resolve, reject))
    })
}

/**
 * Attach a reCAPTCHA v3 token to the register form before it posts.
 *
 * Has to be initialised after initFormValidation: that handler cancels an
 * invalid submit, and this one only asks for a token when nothing did — no point
 * spending a token on a form that is not going anywhere.
 *
 * If no token can be had the form posts without one rather than dead-ending the
 * visitor. The server decides: with reCAPTCHA enabled in FFS Contacts it refuses
 * the submission and index.php renders the error.
 */
export function initRecaptcha() {
    const form = document.querySelector('#register form[data-recaptcha-key]')
    if (!form) return

    const tokenInput = form.querySelector('input[name="g-recaptcha-response"]')
    if (!tokenInput) return

    const siteKey = form.dataset.recaptchaKey

    form.addEventListener('submit', (event) => {
        if (event.defaultPrevented) return

        // No double-submit guard needed here: initFormValidation has already
        // disabled the button, so a second click never reaches this handler.
        event.preventDefault()

        requestToken(siteKey)
            .then((token) => {
                tokenInput.value = token
            })
            .catch((error) => console.warn(error))
            // form.submit() skips the submit event, so this handler doesn't re-enter.
            .finally(() => form.submit())
    })
}
